// actionTypes.js
export const GET_BOOKING_LISTS_REQUEST = "GET_BOOKING_LISTS_REQUEST";
export const GET_BOOKING_LISTS_SUCCESS = "GET_BOOKING_LISTS_SUCCESS";
export const GET_BOOKING_LISTS_FAILURE = "GET_BOOKING_LISTS_FAILURE";

export const GET_SERVICES_REQUEST = "GET_SERVICES_REQUEST";
export const GET_SERVICES_SUCCESS = "GET_SERVICES_SUCCESS";
export const GET_SERVICES_FAILURE = "GET_SERVICES_FAILURE";
